(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["random-fiction-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.randomInitialized) return;
    root.dataset.randomInitialized = 'true';
    const grid = root.querySelector('.grid-uniform');
    const limit = Number(root.dataset.limit) || 8;
    let products = [];
    function draw() {
      if (products.length < limit || !root.isConnected) return;
      const shuffled = products.slice();
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      const fragment = document.createDocumentFragment();
      for (const product of shuffled.slice(0, limit)) {
        const card = document.createElement('div');
        card.className = 'grid__item medium-down--one-half post-large--one-quarter';
        const link = document.createElement('a');
        link.className = 'grid-link';
        link.href = product.url;
        const imageWrap = document.createElement('span');
        imageWrap.className = 'grid-link__image random-fiction__image-wrap';
        const image = document.createElement('img');
        image.className = 'random-fiction__image';
        image.src = product.image;
        image.alt = product.alt || product.title;
        image.width = product.width;
        image.height = product.height;
        image.loading = 'lazy';
        image.decoding = 'async';
        imageWrap.appendChild(image);
        const title = document.createElement('p');
        title.className = 'grid-link__title';
        title.textContent = product.title;
        const price = document.createElement('p');
        price.className = 'grid-link__meta';
        if (product.compare) {
          const previous = document.createElement('s');
          previous.className = 'grid-link__sale_price';
          previous.textContent = product.compare;
          price.append(previous, document.createTextNode(' '));
        }
        price.appendChild(document.createTextNode(product.price));
        link.append(imageWrap, title, price);
        card.appendChild(link);
        fragment.appendChild(card);
      }
      grid.replaceChildren(fragment);
      root.dataset.randomCount = String(Math.min(limit, products.length));
    }
    async function loadProducts() {
      let page = 1;
      let pages = 1;
      const catalog = [];
      do {
        const url = new URL(root.dataset.catalogUrl, window.location.origin);
        url.searchParams.set('page', String(page));
        const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Catalog unavailable');
        const result = await response.json();
        catalog.push(...result.products);
        pages = result.pages;
        page++;
      } while (page <= pages);
      products = [...new Map(catalog.filter(product => product.available && product.image).map(product => [product.id, product])).values()];
      draw();
    }
    loadProducts().catch(() => {});
    window.addEventListener('pageshow', event => { if (event.persisted) draw(); });
  }
  const initialize = scope => scope.querySelectorAll('[data-random-fiction]').forEach(init);
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
